import dynamic from 'next/dynamic';
import { RoomOverviewProps } from './RoomOverview.types';

export const RoomOverview = dynamic<RoomOverviewProps>(() =>
  import('./RoomOverview').then(module => module.RoomOverview)
);
